import { deflateSync } from "fflate";
import memoize from "lodash.memoize";
const getEncoder = memoize(() => new TextEncoder());
const INSTRUCTIONS_SERVICE = "https://instructions.documents.cimpress.io";
export function buildInstructionsRequest(_ref) {
  let {
    document,
    previewType
  } = _ref;
  const documentUri = compressDocument({
    document
  });
  if (previewType === "item") {
    return {
      instructionsUri: "".concat(INSTRUCTIONS_SERVICE, "/v3/instructions:item"),
      documentUri
    };
  }
  return {
    instructionsUri: "".concat(INSTRUCTIONS_SERVICE, "/v3/instructions:preview"),
    documentUri
  };
}
function compressDocument(_ref2) {
  let {
    document
  } = _ref2;
  const documentJson = JSON.stringify(document);
  const encodedValue = getEncoder().encode(documentJson);
  const valueDeflated = deflateSync(encodedValue);
  if (typeof btoa === "undefined") {
    return Buffer.from(valueDeflated).toString("base64");
  }
  return btoa(String.fromCharCode(...valueDeflated));
}